module.exports = __webpack_public_path__ + "img/discts.147e891.webp";